import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { brand, heroBadges, heroImage } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-white pb-16 pt-12 md:pb-24 md:pt-16" data-id="element-91" data-mp="4lqfmm6wsuyr">
      <div className="mx-auto w-full max-w-5xl px-5 text-center md:px-8" data-id="element-92" data-mp="4jm5hmif2zq1">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="mx-auto max-w-4xl text-4xl font-extrabold leading-none tracking-tight text-slate-900 sm:text-5xl md:text-6xl" data-id="element-93" data-mp="1285x3nzc5smb">
          {brand.promise}
          <br data-id="element-94" data-mp="nbyir4alzley" />
          <span className="text-blue-600" data-id="element-95" data-mp="nekm0rqgverd">{brand.promiseAccent}</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease
      }} className="mx-auto mt-5 max-w-3xl text-2xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-3xl" data-id="element-96" data-mp="3czfme2gnud7m">
          {brand.promiseSub}
        </motion.p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease
      }} src={heroImage} alt={brand.mockupCaption} className="mx-auto mt-10 w-full max-w-2xl" width={1240} height={1240} data-id="element-97" data-mp="39b4hj226fw3g" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.18,
        ease
      }} className="mx-auto mt-10 max-w-3xl" data-id="element-98" data-mp="35a2jgojzxq32">
          <p className="text-xl leading-relaxed text-slate-700 md:text-2xl" data-id="element-99" data-mp="2vglq1lnruczx">{brand.subtitle}</p>

          <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm font-semibold text-slate-600" data-id="element-100" data-mp="2hlja05p7n79e">
            {heroBadges.map(badge => <li key={badge} className="inline-flex items-center gap-1.5" data-id="element-101" data-mp="s3ckw8bgjfpi">
                <CheckIcon className="h-4 w-4 text-emerald-500" aria-hidden="true" data-id="element-102" data-mp="na9xyj16r4ia" />
                {badge}
              </li>)}
          </ul>

          <div className="mt-9" data-id="element-103" data-mp="dd5e4putbl4n">
            <CtaButton size="xl" className="w-full max-w-2xl" data-id="element-104" data-mp="de6o0r03e1ks">
              Quiero acceder al Atlas ahora
            </CtaButton>
          </div>

          <p className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-slate-600" data-id="element-105" data-mp="1ayt68yk8jhad">
            <ShieldCheckIcon className="h-4 w-4 text-emerald-500" aria-hidden="true" data-id="element-106" data-mp="15zq0td0cf91v" />
            Garantía de 7 días o te devolvemos tu dinero
          </p>
        </motion.div>
      </div>
    </section>;
}